import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import principle02 from "./layouts/principle-02/principle";
import principle03 from "./layouts/principle-03/principle";
import principle04 from "./layouts/principle-04/principle";
import principle05 from "./layouts/principle-05/principle";
import principle06 from "./layouts/principle-06/principle";
import principle07 from "./layouts/principle-07/principle";
import principle08 from "./layouts/principle-08/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";
import task03 from "./layouts/task-03/task";

const lesson: Lesson = {
  id: "c84314a1-a219-441b-a936-deb13ee34a51",
  publicId: "23",
  name: "Design of listening experiments",
  difficulty: 1,
  contentTypes: { audio: true, interactive: true, video: false },

  body: [
    principle01,
    principle02,
    principle03,
    principle04,
    principle05,
    principle06,
    principle07,
    principle08,
    task01,
    task02,
    task03,
  ],
};

export default lesson;
